import "./HomePart.css";
import slider1 from '../../assets/images/slider1.jpg'
import slider2 from '../../assets/images/slider2.jpg'
import slider3 from '../../assets/images/sldier3.jpg'
import slider4 from '../../assets/images/slider4.jpg'
import slider5 from '../../assets/images/slider5_.jpg'
import { useEffect, useState } from "react";
import { NavLink } from 'react-router-dom';

const photos = [
    slider1,
    slider2,
    slider3,
    slider4,
    slider5
];

function HomePart() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % photos.length);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setCurrent((prev) => (prev + 1) % photos.length);
    };

    const prevSlide = () => {
        setCurrent((prev) => (prev - 1 + photos.length) % photos.length);
    };

    return (
        <div className="hero-section">
            <div className="hero-slider">
                {photos.map((src, index) => (
                    <div
                        key={index}
                        className={`slide ${index === current ? "active" : ""}`}
                        style={{ backgroundImage: `url(${src})` }}
                    ></div>
                ))}
            </div>

            {/* Hero Content */}
            <div className="hero-content">
                <div className="hero-text">
                    <h1 className="hero-title">
                        Welcome to <span className="highlight">SCPO Group Inc</span>
                    </h1>
                    <p className="hero-subtitle">
                        Building lasting partnerships through innovative business solutions. 
                        We deliver excellence in every project, combining creativity with 
                        data-driven insights to help your business grow and succeed.
                    </p>
                    <div className="hero-buttons">
                        <NavLink to="/services" 
                        className="btn btn-primary"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })
                        }>
                            Our Services
                        </NavLink>
                        <NavLink to="/contact" 
                        className="btn btn-secondary"
                         onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })
                        }>
                            Get In Touch
                        </NavLink>
                    </div>
                </div>
            </div>

            {/* Slider Navigation */}
            <div className="slider-nav">
                <button className="nav-btn prev" onClick={prevSlide}>
                    <span>‹</span>
                </button>
                <button className="nav-btn next" onClick={nextSlide}>
                    <span>›</span>
                </button>
            </div>

            {/* Slider Indicators */}
            <div className="slider-indicators">
                {photos.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === current ? "active" : ""}`}
                        onClick={() => setCurrent(index)}
                    />
                ))}
            </div>
        </div>
    )
}

export default HomePart